'use client';

/**
 * Mirror of the shadcn Label in `apps/web/src/components/ui/label.tsx`.
 *
 * A MIRROR rather than a move, for the reasons spelled out in `popover.tsx`:
 * that directory is shadcn-managed and must not be edited, and a re-export
 * shim there would be clobbered by the next `shadcn add`. Identical to the
 * app's copy apart from the import paths — if shadcn regenerates the app's
 * copy, re-apply the same diff here.
 */

import { Label as LabelPrimitive } from 'radix-ui';
import * as React from 'react';

import { cn } from '../lib/utils';

function Label({ className, ...props }: React.ComponentProps<typeof LabelPrimitive.Root>) {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={cn(
        'flex select-none items-center gap-2 text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-50 group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50',
        className,
      )}
      {...props}
    />
  );
}

export { Label };
